import { PayloadAction } from '@reduxjs/toolkit';
import { type Session } from '@/types/session.types';
import { ProjectStateReducerCreator } from '../types';

const saveFieldOnAllSessionsReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<Partial<Session>>) => {
    if (!state.workingProject) return;
    state.workingProject.sessions = state.workingProject.sessions.map((session) => {
      return {
        ...session,
        ...action.payload,
      };
    });
    state.sessionsToUpdateAfterProjectSave = state.workingProject.sessions;
  });
};

export default saveFieldOnAllSessionsReducer;
